import { render, staticRenderFns } from "./communicationLog.vue?vue&type=template&id=58417a4a&scoped=true"
import script from "./communicationLog.vue?vue&type=script&lang=js"
export * from "./communicationLog.vue?vue&type=script&lang=js"
import style0 from "./communicationLog.vue?vue&type=style&index=0&id=58417a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58417a4a",
  null
  
)

export default component.exports